export default {
        apiHost: 'https://' + location.hostname,
        authServer: 'https://auth.lifelonglevelup.com/',
        adminHost: 'https://client.lifelonglevelup.com/admin'
}

